type TDataSetLabels = 'Online' | 'Phone' | 'Register' | 'No appointment'
type TDataSetRef = 'online' | 'phone' | 'register' | 'noAppointment'
type TDataSetColor = 'rgba(255, 99, 132, 0.5)' | 'rgba(53, 162, 235, 0.5)'

export interface IDataSetLabels {
    label: TDataSetLabels
    ref: TDataSetRef
    color: TDataSetColor
}

export const dataSetLabels: IDataSetLabels[] = [
    { label: 'Online', ref: 'online', color: 'rgba(255, 99, 132, 0.5)' },
    { label: 'Phone', ref: 'phone', color: 'rgba(53, 162, 235, 0.5)' },
    { label: 'Register', ref: 'register', color: 'rgba(255, 99, 132, 0.5)' },
    {
        label: 'No appointment',
        ref: 'noAppointment',
        color: 'rgba(53, 162, 235, 0.5)',
    },
]